import React, { useRef, useState } from 'react';
import { auth } from '../firebase';
import { useForm } from 'react-hook-form';
import { FaUserFriends } from 'react-icons/fa';
import { NavLink, Redirect } from 'react-router-dom';

// SIGN UP COMPONENT
export const SignUp = ({ setUserName }) => {
  const [redirect, setRedirect] = useState(false);
  const [userError, setUserError] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');

  const { register, errors, handleSubmit, watch } = useForm({});
  const password = useRef({});
  password.current = watch('password', '');

  const onSubmit = async (data) => {
    auth
      .createUserWithEmailAndPassword(data.email, data.password)
      .then((result) => {
        result.user.updateProfile({
          displayName: data.username,
        });
        setUserName(data.username);
        setUserError(!userError);
        window.localStorage.setItem('emailForSignIn', data.email);
        setRedirect(true);
      })
      .catch((error) => {
        setUserError(!userError);
        setAlertMsg(error.message);
      });
  };

  if (redirect) return <Redirect to="/" />;
  return (
    <section className="sign-in">
      <div className="sign-in__container">
        <div className="sign-in__form">
          <h3 className="sign-in__form--heading">Sign Up!</h3>
          <h6 className="sign-in__form--subheading">
            Please Enter a Username, Email and Password!
          </h6>
          {userError && <p className="sign-in__form--alert">{alertMsg}</p>}
          <form onSubmit={(e) => e.preventDefault()}>
            <input
              className="sign-in__form--input"
              type="text"
              name="username"
              placeholder="Username"
              ref={register({
                required: 'You must enter a username',
                message: 'Enter in a username!',
              })}
            />
            {errors.username && <p className="sign-in__form--alert">{errors.username.message}</p>}
            <input
              className="sign-in__form--input"
              type="email"
              name="email"
              placeholder="Email Address"
              ref={register({
                required: 'You must enter an email',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address!',
                },
              })}
            />
            {errors.email && <p className="sign-in__form--alert">{errors.email.message}</p>}
            <input
              className="sign-in__form--input"
              type="password"
              name="password"
              placeholder="Password (8 characters min)"
              ref={register({
                required: 'You must specify a password',
                minLength: {
                  value: 8,
                  message: 'Password must have at least 8 characters!',
                },
              })}
            />
            {errors.password && <p className="sign-in__form--alert">{errors.password.message}</p>}
            <input
              className="sign-in__form--input"
              type="password"
              name="password_repeat"
              placeholder="Confirm Password"
              ref={register({
                validate: (value) => value === password.current || 'The passwords do not match!',
              })}
            />
            {errors.password_repeat && (
              <p className="sign-in__form--alert">{errors.password_repeat.message}</p>
            )}
            <label className="sign-in__form--terms">
              <input
                type="checkbox"
                name="terms"
                ref={register({
                  required: 'You need to agree!',
                  message: 'You must agree to the terms of use',
                })}
              />
              I accept the
              <a
                href="https://www.linkedin.com/in/ryanroberts0/"
                target="_blank"
                rel="noopener noreferrer"
              >
                &nbsp;terms of use
              </a>
            </label>
            {errors.terms && (
              <p className="sign-in__form--alert">You must agree to the terms of use</p>
            )}
            <button type="submit" className="sign-in__form--btn" onClick={handleSubmit(onSubmit)}>
              Create Account&nbsp; <FaUserFriends />
            </button>
          </form>
          <h6 className="sign-in__form--bottom">
            Return to the&nbsp;
            <NavLink to="/" className="sign-in__form--link">
              Login Page
            </NavLink>
          </h6>
        </div>
      </div>
    </section>
  );
};
